import React from 'react';
import { Grid, Chip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

/**
 * a single chip with the clear icon. calls onClear() when clicked
 */

const ClearChip = ({ value, onClick }) => (
  <Grid container>
    <Grid item>
      <Chip label={value} icon={<ClearIcon onClick={onClick} />} style={{ cursor: 'pointer' }} />
    </Grid>
  </Grid>
);

export default ClearChip;
